// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"2bcae0b7","70":"60bcf79c","173":"ba36a977","284":"b6017ac6","318":"8fec3da4","388":"99f78820","440":"11eb426a","757":"85992231"}[chunkId] + ".chunk.js";
};